import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() disabled: boolean = false;
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() type: string = '';
  @Input() bStyle: string = '';
  @Output() onClick = new EventEmitter<void>();
  class: string = 'button';

  handleClick() {
    this.onClick.emit();
  }
}
